import { TelephonyCallStateEnum } from '../../../enums/telephony-call-state.enum';
import { TelephonyService } from '../../../services';
import { ICallStateData } from '../../../interfaces/telephony/call-state.data';

export function getCallStatusText(state?: ICallStateData): string {
  if (!state || state.callState === TelephonyCallStateEnum.None) {
    return '';
  }

  switch (state.callState) {
    case TelephonyCallStateEnum.Ringing:
      return state.latestEvent?.direction === TelephonyService.EventState_Direction_Incoming
        ? 'Incoming call'
        : 'Outgoing call';

    case TelephonyCallStateEnum.Answered:
      return 'In call';

    case TelephonyCallStateEnum.OnHold:
      return 'On hold';

    case TelephonyCallStateEnum.Ended:
      return 'Ended';

    default:
      return '';
  }
}
